<template>
  <div class="indexBg" style="width: 100%; height: 100%; background-size: cover">
    <div class="logo" @click="toIndex">
      <img src="../../assets/logo.png" alt="logo" />
    </div>

    <div class="loginType">
      <el-tabs v-model="isActiveName">
        <el-tab-pane label="登录" name="first">
          <div class="login-top">
            <div v-show="typeInfo == 1">
              <el-form :model="loginForm" ref="loginForm" class="demo-ruleForm">
                <div v-if="activeIndex == 1" v-loading="loadingLogin">
                  <el-form-item prop="username" :rules="formRules.require" key="loginForm.username">
                    <el-input clearable v-model="loginForm.username" placeholder="请输入手机号或登录账号"></el-input>
                  </el-form-item>
                  <el-form-item prop="password" :rules="formRules.require" key="loginForm.password">
                    <el-input
                      clearable
                      ref="password"
                      type="password"
                      style="margin-top: 20px"
                      v-model="loginForm.password"
                      placeholder="请输入密码"
                      @keyup.enter.native="clickLogin"
                    ></el-input>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item prop="phone" :rules="formRules.phone" key="loginForm.phone">
                    <!-- <div style="display: flex;" class="tcolor">
                      <el-select v-model="valueNum" filterable placeholder="请选择" style="width: 30%; border-right:none;border-radius:0px;" @change="handleSelect">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          style="border-right:none;border-radius:0px;"
                          :label="'+'+item.tel"
                           :remote-method="remoteMethod"
                          :value="item.tel">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 30px;">+{{ item.tel }}</span>
                        </el-option>
                      </el-select>
                      <el-input
                        clearable
                        style="width: 70%;border-left:none;border-radius:0px;!important"
                        v-model="loginForm.phone"
                        class="el-inputs"
                        type="tel"
                        maxlength="11"
                        placeholder="请输入手机号"
                      ></el-input>
                    </div>-->
                    <el-input
                      placeholder="请输入手机号"
                      maxlength="11"
                      clearable
                      v-model="loginForm.phone"
                      class="input-with-select"
                    >
                      <el-select
                        v-model="valueNum"
                        filterable
                        slot="prepend"
                        placeholder="请选择"
                        @change="handleSelect"
                        style="width: 100px;"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="'+'+item.tel"
                          :remote-method="remoteMethod"
                          :value="item.tel"
                        >
                          <span style="float: left">{{ item.name }}</span>
                          <span
                            style="float: right; color: #8492a6; font-size: 13px;margin-left: 30px;"
                          >+{{ item.tel }}</span>
                        </el-option>
                      </el-select>
                    </el-input>
                    <!-- <el-input
                      clearable
                      v-model="loginForm.phone"
                      type="tel"
                      maxlength="11"
                      placeholder="请输入手机号"
                    ></el-input>-->
                  </el-form-item>

                  <el-form-item prop="codenum" :rules="formRules.phoneCode" key="loginForm.codenum">
                    <el-input
                      style="margin-top: 20px"
                      v-model="loginForm.codenum"
                      placeholder="请输入验证码"
                      maxlength="4"
                      @keyup.enter.native="clickLogin"
                    >
                      <el-button
                        style="margin-top: 5px; margin-right: 8px"
                        slot="suffix"
                        @click="sendLoginPhoneCode"
                        type="text"
                      >获取验证码</el-button>
                    </el-input>
                  </el-form-item>
                </div>

                <el-form-item>
                  <el-button
                    id="pageLogin"
                    style="
                      width: 100%;
                      height: 50px;
                      border-radius: 10px;
                      margin-top: 20px;
                    "
                    type="primary"
                    @click="clickLogin()"
                  >登录</el-button>
                </el-form-item>
              </el-form>
              <div style="text-align: center; margin-top: 30px">
                <el-checkbox v-model="value">我已阅读并同意</el-checkbox>
                <span
                  @click="registerPolicyDialog = true"
                  data-v-9aa3ee46
                  :style="{ color: value ? '#FF4D01' : '#787676' }"
                  style="cursor: pointer;"
                >《货代拼用户服务条款》</span>
                ，如您还没有注册账号，系统将自动创建货代拼账号
              </div>
            </div>
            <!-- 微信扫码登录 -->
            <div v-if="typeInfo == 2" class="code-login">
              <div class="tips"></div>
              <div class="login-wx-code">
                <div
                  id="wx_login_container"
                  style="
                    transform: scale(0.9);
                    margin-top: -30px;
                    margin-left: 34px;
                  "
                ></div>
              </div>
            </div>
          </div>

          <el-divider>其它方式登录</el-divider>

          <div class="longin-bottom">
            <div class="txtType" v-show="typeInfo == 1" @click="handleImgs(1)">
              <img src="../../assets/wechet.png" alt="wechet" />
              <p>微信扫码登录</p>
            </div>

            <div class="txtType" v-show="typeInfo == 2" @click="handleImgs(2)">
              <img src="../../assets/yanzhen.png" alt="yanzhen" />
              <p style="margin-left: 12px">验证码登录</p>
            </div>

            <div
              class="txtType"
              style="margin-left: 54px"
              @click="handleClick(1)"
              v-if="activeIndex == 1"
            >
              <img src="../../assets/yanzhen.png" alt="yanzhen" />
              <p style="margin-left: 12px">验证码登录</p>
            </div>
            <div
              class="txtType"
              style="margin-left: 54px"
              @click="handleClick(0)"
              v-if="activeIndex == 0"
            >
              <img src="../../assets/password.png" alt="yanzhen" />
              <p style="margin-left: 22px">密码登录</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="注册" name="seccond">
          <el-form style="margin-top: 40px" :model="userForm" ref="form" class="demo-ruleForm">
            <el-form-item prop="name" :rules="formRules.require" style="margin-bottom: 28px">
              <el-input clearable v-model="userForm.name" placeholder="用户名"></el-input>
            </el-form-item>
            <!--<el-form-item prop="inviteCode" style="margin-bottom: 28px">
              <el-input clearable v-model="userForm.inviteCode" placeholder="邀请码"></el-input>
            </el-form-item>-->
            <el-form-item prop="phoneNo" :rules="formRules.phone" style="margin-bottom: 28px">
              <!-- <div style="display: flex;">
                      <el-select v-model="valueNum" filterable placeholder="请选择" style="width: 30%;border-right:none;border-radius:0px;" @change="handleSelect">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          style="border-right:none;border-radius:0px;"
                          :label="'+'+item.tel"
                           :remote-method="remoteMethod"
                          :value="item.tel">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 30px;">+{{ item.tel }}</span>
                        </el-option>
                      </el-select>
                <el-input
                  clearable
                  style="width: 70%;border-left:none;border-radius:0px;!important"
                  v-model="userForm.phoneNo"
                  class="el-inputs"
                   type="tel"
                  placeholder="请输入手机号"
                ></el-input>
              </div>-->
              <el-input
                placeholder="请输入手机号或登录账号"
                clearable
                v-model="userForm.phoneNo"
                class="input-with-select"
              >
                <el-select
                  v-model="valueNum"
                  filterable
                  slot="prepend"
                  placeholder="请选择"
                  @change="handleSelect"
                  style="width: 100px;"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="'+'+item.tel"
                    :remote-method="remoteMethod"
                    :value="item.tel"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px;margin-left: 30px;"
                    >+{{ item.tel }}</span>
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" :rules="formRules.require" style="margin-bottom: 28px">
              <el-input clearable type="password" v-model="userForm.password" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item
              prop="comPassword"
              :rules="formRules.confirmPassword"
              style="margin-bottom: 28px"
            >
              <el-input clearable type="password" v-model="userForm.comPassword" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item
              prop="verificationCode"
              :rules="formRules.phoneCode"
              style="margin-bottom: 28px"
            >
              <el-input maxlength="4" v-model="userForm.verificationCode" placeholder="请输入验证码">
                <el-button
                  style="margin-top: 5px; margin-right: 8px"
                  slot="suffix"
                  @click="getSetCode"
                  type="text"
                >
                  {{
                  countDown > 0 ? countDown + "S" : "获取验证码"
                  }}
                </el-button>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                id="pageRegister"
                style="
                  width: 100%;
                  height: 60px;
                  border-radius: 10px;
                  margin-top: 20px;
                "
                type="primary"
                @click="clickRegister('form')"
              >注册</el-button>
            </el-form-item>
          </el-form>

          <div style="text-align: center; margin-top: 30px">
            <el-checkbox v-model="value">
              我已阅读并同意
              <span @click="registerPolicyDialog = true" data-v-9aa3ee46>《货代拼用户服务条款》</span>
            </el-checkbox>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 协议条款弹窗 -->
    <el-dialog title="服务条款" center :visible.sync="registerPolicyDialog" width="50%">
      <div style>
        <p style="font-size: 26px">服务条款</p>
        <p>协议构成及须知</p>
        <p>
          1.
          本协议是货代拼网络平台注册用户（包括使用货代拼网络平台的个人和所代表的企业）与货代拼网络平台之间的法律契约，注册货代拼网络平台即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即货代拼用户）且自发出协议之时即受协议条款的约束。
        </p>
        <p>
          2.
          本协议受中华人民共和国法律管辖，签约地为深圳。下文中的货代拼是本协议的契约方之一。下文中的“用户”指货代拼网络平台注册用户，是本协议的契约方之另一方。
        </p>
        <p>
          3.
          用户欲访问和使用货代拼网络平台，必须事先认真阅读本协议中的各项条款，包括免除或者限制货代拼网络平台责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款或随时对其的修改，请不使用或主动取消货代拼网络平台提供的服务。对货代拼网络平台的使用行为将被视为对本协议条款的完全接受，包括接受货代拼网络平台对条款所做的任何修改。
        </p>
        <p style="font-size: 22px">用户使用规则</p>
        <p>
          1.
          货代拼网络平台服务仅限于为用户提供正常和合法业务工具，用户如果使用货代拼网络平台产品从事以下行为，即导致根本性违约，货代拼网络平台有权随时停止服务、解除本协议，并追讨因此带来的损失：
          1）有明确证据表明用户使用货代拼网络平台用于违反法律的业务。用户发送了任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽等内容的信息。
          2）对货代拼网络平台产品进行了任何形式的对其他第三方的再授权使用，销售或转让。
          3）提供的公司信息或个人资料不真实，或有可能对货代拼网络平台其他用户构成误导甚至欺诈。
          4）滥用货代拼网络平台产品的通信功能发送垃圾邮件和短信。
          5）对货代拼网络平台的连续服务和商誉构成损害的其他行为，包括对货代拼网络平台服务器的攻击。
          6）其他货代拼网络平台认为是不符合整体服务需求的特殊情形。
        </p>
        <p>
          2.
          货代拼网络平台使用用户所拥有的互联网域名所对应的电子邮件地址作为用户权证的唯一识别信息。当用户不再拥有在货代拼网络平台所登记的域名时，货代拼网络平台有权随时删除该用户的所有数据。
        </p>
        <p>
          3.
          用户必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。
        </p>
        <p style="font-size: 22px">知识产权</p>
        <p>
          1.
          用户完全拥有在使用货代拼网络平台时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从货代拼网络平台中复制、导出和删除。
        </p>
        <p>
          2.
          航迅（深圳）网络科技有限公司完全拥有货代拼网络平台的全部知识产权，用户签署本协议后并未拥有货代拼网络平台的所有权。航迅（深圳）网络科技有限公司的公司名称、标志、LOGO、产品名字，以及货代拼网络平台的应用程序、源代码、界面设计、应用程序编程接口（API）等所关联的知识产权都归属航迅（深圳）网络科技有限公司，未经授权不能使用。
        </p>
        <p>
          3.
          用户不得将涉及货代拼网络平台拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。用户不得出售、转售或复制货代拼网络平台产品，亦不可基于商业目的模仿货代拼网络平台的产品和服务。用户不可复制和模仿货代拼网络平台的设计理念、界面、功能和文字及图形说明。未经航迅（深圳）网络科技有限公司许可，用户不得基于此协议所约定的服务对货代拼网络平台进行修改或制造、衍生其它产品。
        </p>

        <p style="font-size: 22px">数据安全及保密</p>

        <p>
          1.
          货代拼网络平台每天都对用户储存在货代拼服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。
        </p>
        <p>
          2.
          用户有义务维护自己在货代拼网络平台中的账户信息的完整性、密码的保密性。因用户维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由用户自行负责。用户不得向他人提供货代拼网络平台的全部或部分服务，也不得容许他人通过自己的账户使用货代拼网络平台。
        </p>
        <p>
          3.
          货代拼的客服人员不接受用户的口头请求对其密码进行重置。对所有用户输入的信息和上传的文件，
          货代拼员工不能对其进行其他任何侵犯隐私的操作。
        </p>
        <p>
          4.
          用户对其输入数据的准确性、可靠性、合法性、适用性等自行负责。用户不可破坏货代拼网络平台的安全或授权措施，不可翻阅或存取非自己所有的数据。
        </p>
        <p>
          5.
          除应政府或司法机关调查或法律要求外，航迅（深圳）网络科技有限公司直接口头或书面向第三方提供涉及用户在使用货代拼网络平台过程中保存在货代拼服务器上的数据的行为属于泄密行为，所造成对用户的直接损失，并经证实，用户有权通过法律途径要求货代拼按协议相应条款赔偿。
        </p>
        <p>
          6.
          本条款中的保密义务、权利和责任不适用于如下信息：(1)非由于货代拼不正当的原因已经为公众所知的；(2)由货代拼以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；(3)经用户授权发布的信息;
          (4)由于法律、法院或其他国家有权机关的要求而披露的信息。
        </p>
        <p>
          7.
          货代拼保留使用汇总统计信息的权利，但这些信息是匿名，且不针对特定用户的。
        </p>
        <p>
          8.
          航迅（深圳）网络科技有限公司保留面向基础版用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度，但货代拼不会将用户的个人信息透露给广告商，而只会在匿名的基础上通过自动化匹配技术实现广告优化刊载。
        </p>
        <p style="font-size: 22px">不可抗力及免责条款</p>
        <p>
          1.
          因一切不由货代拼可控因素引起的服务中断和长时间终止不属于货代拼违约，不承担赔偿责任。不可控因素包括但不限于：
          1）用户方客户终端硬件及网络，互联网络，机房供电系统故障；
          2）不可抗力： 地震、台风、洪水等自然灾害；
          战争、罢工、停电、政府行为等； 政府电力部门或电信部门的行为；
          电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；
          INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；
          外部人为破坏因素引起的，超过安全设备的承载能力。
          3）其它不可预见、不可避免、不可克服和不可控制的不可抗力。
        </p>
        <p>遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。</p>

        <p>
          2.
          货代拼不保证网址所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。
        </p>
        <p>
          3.
          货代拼对任何损害概不负责，无论这些损害是否由于使用、不能使用本平台的结果或由连到本平台的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果用户由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，用户须承担由此而造成的所有费用。
        </p>
        <p>
          4.
          在任何情况下，货代拼对于与使用或未能使用本平台或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。
        </p>
        <p>
          5.
          货代拼网络平台、论坛、博客中的所有言论并不代表货代拼的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对用户造成伤害，货代拼将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但货代拼不承担任何责任。
        </p>
        <p style="font-size: 22px">条款修订</p>
        <p>
          1.
          货代拼有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在货代拼网站。
        </p>
        <p>2. 修订的条款始终公开在货代拼网络平台条款页面</p>
        <p style="font-size: 22px">争议解决</p>
        <p>如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。</p>
      </div>
    </el-dialog>
    <!-- 协议条款弹窗 end -->
  </div>
</template>

<script>
import qs from "qs"
import { options } from "./areaCode.js"
import {isObject, sendCustomerOperationRecord} from "@/assets/js/utils"
import { loginSaveUserData } from "@/assets/js/utils.login"
import {
  rulesNotEmpty,
  getRegExpPhone,
  rulesPhone,
} from "@/assets/js/formRules"
export default {
  name: "JiuyuProjectIndex",
  data () {
    let validatePass = (rule, value, callback) => {
      if (value !== this.userForm.password) {
        callback(new Error("两次输入密码不一致!"))
      } else {
        callback()
      }
    }
    let handlePhone = (rule, value, callback) => {
      if (this.valueNum == "86") {
        if (!/^1[3-9][0-9]{9}$/.test(value)) {
          callback(new Error("手机号码格式有误(11位，13-19开头)"))
        } else {
          callback()
        }
      } else {
        callback()
      }
      // console.log("=====111", rule, value, callback)
      // callback()
    }
    return {
      options: options,
      valueNum: '86',
      isActiveName: "first",
      loginForm: {
        username: "",
        password: "",
        phone: "",
        codenum: "",
      },

      loginRuleForm: {},
      value: false,
      /*服务条款*/
      registerPolicyDialog: false,
      activeIndex: 1, //1、账号 0、是验证码
      typeInfo: 1, //1: 微信扫码登录 2: 账号密码登录
      loadingLogin: false,
      logintType: null, //其他页面调用登录窗时传入的值
      countDown: 0, //注册短信倒计时
      userForm: {
        email: "",
        cusType: "",
        name: "",
        password: "",
        comPassword: "",
        phoneNo: "",
        verificationCode: "",
      },
      timer: null, // 清除计时器
      formRules: {
        no: [{ trigger: "blur", required: false }],
        require: [rulesNotEmpty()],
        phone: [rulesNotEmpty("手机号"), {
          // pattern: /^[1-9]{0,20}$/,
          validator: handlePhone,
          trigger: "blur"
        }],
        phoneCode: [
          rulesNotEmpty(),
          {
            pattern: /[A-Za-z0-9]{4}/,
            trigger: "blur",
            message: "4位数字、字母",
          },
        ],
        confirmPassword: [
          rulesNotEmpty(),
          { validator: validatePass, trigger: "blur" },
        ],
      },
    }
  },

  mounted () {
    if (this.$route.query.indexLoginMsg) {
      this.$message({
        type: "error",
        message: this.$route.query.indexLoginMsg,
      })
      // this.$router.push("/")
      setTimeout(() => {
        this.$router.push("/index")
      }, 3000)
    };
    this.fillLoginAccount()

    // if (this.$route.query.qrCode) {
    //   let data = {
    //     code: this.$route.query.qrCode,
    //   };
    //   // return
    //   this.axios
    //     .post(`/user/loginByWechatCode`, qs.stringify(data))
    //     .then((resData) => {
    //       if (resData.data.code == 200) {
    //         this.$store.state.Authorization = resData.data.data;
    //         this.info = resData.data.data;
    //         // // debugger
    //         // if(resData.data.data.isBindedWebOpenId){
    //         //    this.visiable = false
    //         // }
    //         localStorage.setItem(
    //           "Authorization",
    //           JSON.stringify(resData.data.data)
    //         );
    //         sessionStorage.setItem(
    //           "Authorization",
    //           JSON.stringify(resData.data.data)
    //         );
    //         this.$message({
    //           type: "success",
    //           message: "登录成功",
    //         });
    //         //  console.log('resData.data.data.isBindedWebOpenId: ', resData.data.data.isBindedWebOpenId);
    //         //           if(resData.data.data.isBindedWebOpenId){
    //         //             this.visiable = true
    //         //           }
    //       } else {
    //         this.$message({
    //           type: "error",
    //           message: resData.data.message,
    //         });
    //       }
    //     });
    // }
  },
  watch: {
    countDown (val) {
      if (val <= 0) {
        clearInterval(this.timer)
      }
    },
    $route: {
      handler (val, oldval) {

      },
      // 深度观察监听
      deep: true,
    },
  },

  methods: {
    // 搜索手机区号
    remoteMethod (query) {
      if (query !== '') {
        setTimeout(() => {
          this.options = this.options.filter(item => {
            return item.tel.indexOf(query) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    // 选中手机号前缀
    handleSelect (e) {
      console.log("111111", e, this.valueNum)
      this.userForm.phoneNo = ""
      this.loginForm.phone = ""
    },
    //   切换登录
    handleClick () {
      //   this.activeIndex = this.activeIndex === 0 ? 1 : 0;
      if (this.activeIndex == 1) {
        this.activeIndex = 0
      } else {
        this.activeIndex = 1
        this.typeInfo = 1
      }
    },

    /**
     * 注册发送短信
     */
    getSetCode () {
      if (this.countDown > 0) {
        this.$message({ message: "请" + this.countDown + "秒后再发送" })
        return false
      }
      if (!this.userForm.phoneNo) {
        this.$message.info("请填写手机号")
        return
      }
      let phone = this.valueNum + "," + this.userForm.phoneNo
      this.axios
        .get("/corporation/requestRegisterSmsCode/" + phone)
        .then((res) => {
          if (res.data.code !== 200) {
            return Promise.reject(
              new Error(res.data.message || "发送登录短信失败")
            )
          }
          this.$message.success("发送登录短信成功")
          if (this.timeOut >= 0) clearInterval(this.timeOut)
          this.countDown = 60
          this.timeOut = setInterval(() => {
            this.countDown--
            if (this.countDown <= 0) {
              clearInterval(this.timeOut)
            }
          }, 1000)
        })
        .catch((res) => {
          this.$message.error(res.message || "登录失败,请稍后重试")
        })
    },

    /**
     * 点击注册
     */
    clickRegister (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          // this.$message.error('请补全注册信息');
          return false
        }
        if (!this.value) {
          return this.$message.error("请阅读后同意《服务条款》！")
        }
        this.register()
      })
    },

    /**
     * 提交注册
     */
    register () {
      // 判断那种注册
      this.userForm.cusType = "G"
      this.loadingRegister = true
      this.userForm.phoneNo = this.valueNum + "," + this.userForm.phoneNo
      console.log("register", this.userForm)
      this.axios
        .post(`/corporation/registerCustomer`, this.userForm)
        .then((res) => {
          if (res.data.code !== 200) {
            return Promise.reject(
              new Error(res.data.message || "网络错误,请重试")
            )
          }
          this.loadingRegister = false
          this.$message.success("注册成功")
          this.loginForm.username = this.userForm.phoneNo
          this.loginForm.password = this.userForm.password
          this.$refs["form"].resetFields()
          this.$nextTick(() => {
            this.clickLogin()
          })
        })
        .catch((res) => {
          setTimeout(() => {
            this.loadingRegister = false
            this.$message.error(res.message || "注册失败,请稍后重试")
          }, 500)
        })
    },

    //   登录方法
    clickLogin () {
      console.log('111')
      let formName = "loginForm"
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.value) {
            return this.$message.error("请阅读后同意《服务条款》！")
          }
          console.log("55555", this.activeIndex)
          if (this.activeIndex == 0) {
            this.loginUsePhone()
          } else {
            this.loginUseAccount()
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })

    },

    /**
     * 使用账号登录
     */
    loginUseAccount (options) {
      let username = this.loginForm.username
      console.log("xxxxxx", username)
      let params = isObject(options)
        ? options
        : {
          username: username,
          password: this.loginForm.password,
        }
      this.loadingLogin = true
      this.axios
        .post("/user/login", qs.stringify(params))
        .then((res) => {
          if (res.data.code !== 200) {
            return Promise.reject(
              new Error(res.data.message || "网络错误,请重试")
            )
          }
          if (!isObject(res.data.data)) {
            return Promise.reject(new Error("登录成功返回数据异常"))
          }
          this.loadingLogin = false
          if (!res.data.data.isBindedWebOpenId) {
            this.$store.state.dialogShow = true
          }
          this.loginSuccess(res.data.data)
          let logInfo = JSON.stringify({
            account: username,
            activeName: 0
          })
          localStorage.setItem('login-account', logInfo)
        })
        .catch((res) => {
          setTimeout(() => {
            this.loadingLogin = false
            this.$message.error(res.message || "登录失败,请稍后重试")
          }, 500)
        })
    },
    /**
     * 使用短信验证码登录
     */
    loginUsePhone () {
      let phoneNo = this.valueNum + "," + this.loginForm.phone
      let params = {
        phoneNo: phoneNo,
        smsCode: this.loginForm.codenum,
      }
      console.log("999888", params)
      // return
      this.loadingLogin = true
      this.axios
        .post("/user/loginBySmsCode", qs.stringify(params))
        .then((res) => {
          if (res.data.code !== 200) {
            return Promise.reject(
              new Error(res.data.message || "网络错误,请重试")
            )
          }
          if (!isObject(res.data.data)) {
            return Promise.reject(new Error("登录成功返回数据异常"))
          }
          this.loadingLogin = false
          this.loginSuccess(res.data.data)
          let logInfo = JSON.stringify({
            account: this.loginForm.phone,
            activeName: 1
          })
          localStorage.setItem('login-account', logInfo)
        })
        .catch((res) => {
          setTimeout(() => {
            this.loadingLogin = false
            this.$message.error(res.message || "登录失败,请稍后重试")
          }, 500)
        })
    },

    /**
     * 登录成功
     */
    loginSuccess (data = {}) {
      loginSaveUserData(data)
      sendCustomerOperationRecord("登录","登录页");
      this.$store.commit("changeloginShow", false)
      this.$message({ showClose: true, message: "登录成功", type: "success" })
      this.$store.commit("changeactive", 0)
      if (this.logintType === 2) this.$parent.getFiledata("login")
      this.$router.push({
        name: "userCountshow",
      })
      this.$store.commit("changeSetType", false)

      console.log('$store.state.activeType', this.$store.state.activeType)
    },

    showDialog (num) {
      this.logintType = num
      this.$store.commit("changeloginShow", true)
    },
    /**
     * 切换 微信扫码/账号密码 登录
     */
    handleImgs (val) {
      if (val == 1) {
        this.typeInfo = 2
        this.activeIndex = 0
        this.handleCodeLogin()
      } else {
        this.typeInfo = 1
        clearInterval(this.timer)
      }
    },

    /**
     * 切换为  微信扫码登录 时
     */
    handleCodeLogin () {
      // let isIndexPage=false;
      this.axios
        .get(`/wechatUser/qrCodeCreateLogin`, {
          params: { isIndexPage: "true" },
        })
        .then((res) => {
          if (res.data.code == 200) {
            // this.timer = setInterval(() => {
            //   this.statusCode(res.data.data.qrKey);
            // }, 1000 * 600);
            this.$nextTick(() => {
              let address = res.data.data.qrCode
              console.log("11111x999---", address)
              // debugger
              var obj = new WxLogin({
                self_redirect: false,
                id: "wx_login_container",
                appid: res.data.data.appId,
                scope: "snsapi_login",
                // redirect_uri:
                //   "https://sales-qa.18jiuyu.com/jiuyu/backend/salesman/wechatUser/qrCodeNotify",
                // redirect_uri: "http://qa.18jiuyu.com/api/wechatUser/loginNotify",
                // redirect_uri: "http://qa.18jiuyu.com/api/wechatUser/bindNotify",
                redirect_uri: address,
                state: res.data.data.qrKey,
                style: "black",
                href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZXsNCiAgICAgd2lkdGg6IDI2MHB4OyAgICAgICAgICAgDQp9DQouaW1wb3dlckJveCAuc3RhdHVzIHsNCiAgICBwYWRkaW5nOiA3cHggMTRweDsNCiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7DQp9",
              })
            })
          } else {
            this.$message({ message: res.data.message, type: "error" })
          }
        })
    },

    // 获取验证码
    sendLoginPhoneCode () {
      if (this.loginCodeTime > 0) {
        this.$message({ message: "请" + this.loginCodeTime + "秒后再发送" })
        return false
      }
      if (!this.loginForm.phone) {
        this.$message.info("请先输入手机号")
        return false
      }
      let phone = this.valueNum + "," + this.loginForm.phone
      console.log("phone", phone)
      this.axios
        .get(`/user/requestLoginSmsCode/${phone}`)
        .then((res) => {
          if (res.data.code !== 200) {
            return Promise.reject(
              new Error(res.data.message || "发送登录短信失败")
            )
          }
          this.$message.success("发送登录短信成功")
          if (this.loginCodeTimeOut >= 0) clearInterval(this.loginCodeTimeOut)
          this.loginCodeTime = 60
          this.loginCodeTimeOut = setInterval(() => {
            this.loginCodeTime--
            if (this.loginCodeTime <= 0) {
              clearInterval(this.loginCodeTimeOut)
            }
          }, 1000)
        })
        .catch((res) => {
          this.$message.error(res.message || "登录失败,请稍后重试")
        })
    },

    /**
     * 请求获取扫码登录状态
     */
    statusCode (val) {
      this.axios
        .get("/wechatUser/queryWechatLoginState?" + `state=${val}`)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data) {
              let data = {
                code: res.data.data,
              }
              // this.axios
              //   .post(`/user/loginByWechatCode`, qs.stringify(data))
              //   .then((resData) => {
              //     console.log("res---", resData);
              //     if (resData.data.code == 200) {
              //       this.loginSuccess(res.data.data);
              //       clearInterval(this.timer);
              //       this.$router.go();
              //       // this.$router.push("/");
              //       this.$message({
              //         type: "success",
              //         message: "登录成功",
              //       });
              //     } else {
              //       this.$message({
              //         type: "error",
              //         message: resData.data.message,
              //       });
              //     }
              //   });
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            })
            // clearInterval(this.timer);
          }
        })
    },

    //跳转辉首页
    toIndex () {
      this.$router.push("/")
    },
    fillLoginAccount() {
      let accountInfo = JSON.parse(localStorage.getItem('login-account'))
      if (!accountInfo) return
      if (accountInfo.activeName === 0) {
        this.loginForm.username = accountInfo.account
        this.$nextTick(() => {
          this.$refs.password.focus()
          this.$refs.loginForm.clearValidate(['password'])
        })
      } else {
        this.loginForm.phone = accountInfo.account
      }
    }
  },
  computed: {
    /**
     * 能否发送登录短信
     */
    canSendLoginPhoneCode () {
      let phone = this.loginForm.phone || ""
      return getRegExpPhone().test(phone) && this.loginCodeTime <= 0
    },
    /**
     * 能否发送注册短信
     */
    canSendRegisterPhoneCode () {
      let phone = this.userForm.phoneNo || ""
      return getRegExpPhone().test(phone) && this.countDown <= 0
    },
  },
};
</script>

<style scoped lang="scss">
.indexBg {
  background: url('../../assets/indexFBA.png') 100% no-repeat;
  position: relative;
}

.logo {
  width: 178px;
  height: 68px;
  position: absolute;
  top: 60px;
  left: 103px;
  display: -webkit-flex;
  align-items: center;
  cursor: pointer;
}

.loginType {
  width: 508px;
  height: 760px;
  background-color: #fff;
  position: absolute;
  right: 197px;
  box-shadow: 0px 0px 27px 0px rgba(185, 57, 71, 0.01);
  border-radius: 40px;
  box-sizing: border-box;
  padding: 56px 30px 30px 30px;
  top: 40px;
  box-shadow: 10px 10px 10px 10px rgba(155, 155, 155, 0.32);
}

.loginType >>> .el-tabs__nav-wrap::after {
  background: none;
}

.loginType >>> .el-tabs__item {
  font-size: 26px;
  font-weight: 600;
  color: #000;
}

.login-top {
  width: 100%;
  height: 334px;
  /* background-color: pink; */
  margin-top: 40px;
  box-sizing: border-box;
}

/deep/ .el-input__inner {
  height: 50px;
  line-height: 50px;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  &::placeholder {
    font-size: 16px;
  }
}

/deep/.el-input {
  font-size: 16px;
}

.loginType >>> .el-divider__text {
  color: #bcbcbc;
  font-size: 14px;
}

.longin-bottom {
  width: 100%;
  height: 160px;
  margin-top: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.longin-bottom .txtType {
  width: 100px;
  height: 94px;
  box-sizing: border-box;
  cursor: pointer;
}

.txtType img {
  width: 40px;
  height: 40px;
  margin-left: 28px;
}

.txtType p {
  margin-left: 4px;
  margin-top: 10px;
  font-size: 14px;
}

.code-login {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
}

.tips {
  position: relative;
  width: 50;
  height: 40px;
  left: 140px;
  background-color: white;
  // margin-top: -36px;
  z-index: 999;
  top: -40px;
}

.login-wx-code {
  margin-top: -90px;
}
// .impowerBox .qrcode{
//   width: 100% !important;
// }
.show-imgs img {
  width: 38px;
}

.impowerBox >>> p {
  font-size: 18px !important;
}

.demo-ruleForm >>> .el-input__inner {
  border-radius: 0px;
}

// .el-select >>> .el-input__inner{
//   border-right: none;
//   // background: #e8f0fe;
// }
.el-inputs >>> .el-input__inner {
  border-left: none;
}
// .el-select >>> .is-focus .el-input__inner {
//     border-color: #dcdcdc !important;
// }
// .indexBg >>>  .el-select .el-input__inner:focus {
//     border-color: #F56C6C !important;
// }

// .indexBg >>> .el-select .el-input.is-focus .el-input__inner {
//     border-color: #F56C6C;
// }
// .indexBg >>> .el-select .el-input.is-focus .el-input__inner {
//     border-color: #dcdcdc;
// }

</style>
<style>
#wx_login_container > iframe {
  width: 330px !important
}
</style>



// WEBPACK FOOTER //
// src/components/FBAindex/index.vue